var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 13.0134 18.6672 15.7154 16.5588 17.5488C14.8031 19.0756 12.5095 20 10 20C7.49052 20 5.19694 19.0756 3.44117 17.5488C1.33285 15.7154 0 13.0134 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 17C11.7567 17 13.3622 16.3529 14.5912 15.2842C14.7327 15.1611 14.8692 15.0325 15.0003 14.8986C13.9194 13.1503 12.0833 12 10 12C7.91675 12 6.0806 13.1503 4.99969 14.8986C5.13086 15.0325 5.26735 15.1611 5.40884 15.2842C6.63788 16.3529 8.24339 17 10 17ZM10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceUserIcon);
export default __webpack_public_path__ + "static/media/serviceUserIcon.93662302cb26a8b347a79907096c34f2.svg";
export { ForwardRef as ReactComponent };